// extracted by mini-css-extract-plugin
module.exports = {"container":"Feedback_container__L17QF","barcode":"Feedback_barcode__1s813","addMargin":"Feedback_addMargin__2703_"};